var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuickActionRedeem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24,
    r: 24,
    fill: "#E50914"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22C15.5 21.0572 15.5 20.5858 15.7929 20.2929C16.0858 20 16.5572 20 17.5 20H31.5C32.4428 20 32.9142 20 33.2071 20.2929C33.5 20.5858 33.5 21.0572 33.5 22V23.5C33.5 23.9659 33.5 24.1989 33.4239 24.3827C33.3224 24.6277 33.1277 24.8224 32.8827 24.9239C32.6989 25 32.4659 25 32 25V25C31.5341 25 31.3011 25 31.1173 25.0761C30.8723 25.1776 30.6776 25.3723 30.5761 25.6173C30.5 25.8011 30.5 26.0341 30.5 26.5V30C30.5 30.9428 30.5 31.4142 30.2071 31.7071C29.9142 32 29.4428 32 28.5 32H20.5C19.5572 32 19.0858 32 18.7929 31.7071C18.5 31.4142 18.5 30.9428 18.5 30V26.5C18.5 26.0341 18.5 25.8011 18.4239 25.6173C18.3224 25.3723 18.1277 25.1776 17.8827 25.0761C17.6989 25 17.4659 25 17 25V25C16.5341 25 16.3011 25 16.1173 24.9239C15.8723 24.8224 15.6776 24.6277 15.5761 24.3827C15.5 24.1989 15.5 23.9659 15.5 23.5V22Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 25H31.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 19L24.5 32",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 19L23.6214 18.1214C22.5551 17.0551 21.2552 16.2517 19.8246 15.7749V15.7749C18.681 15.3937 17.5 16.2449 17.5 17.4503V17.6325C17.5 18.4491 18.0226 19.1742 18.7974 19.4325L20.5 20",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 19L25.3786 18.1214C26.4449 17.0551 27.7448 16.2517 29.1754 15.7749V15.7749C30.319 15.3937 31.5 16.2449 31.5 17.4503V17.6325C31.5 18.4491 30.9774 19.1742 30.2026 19.4325L28.5 20",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickActionRedeem);
export default __webpack_public_path__ + "static/media/quick-action-redeem.7673c6e45a792f98cd71c3190fa1afb5.svg";
export { ForwardRef as ReactComponent };